<div class="ui-g component-container" *ngIf="isApplicationActive">
  <ng-container *ngFor="let item of allPanels">
    <div
      class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-4 ui-sm-6 ui-xs-6 tiles-padding"
      *ngIf="!isCustomer && item.id === 'new-installation' && item.display">
      <div id="new-installation" class="pointer-cursor" (click)="redirectTo(installationFlowType.NewInstallation)">
        <div class="placeholder-tiles">
          <div class="placeholder-img">
            <img alt="zaehlereinbau" src="assets/images/icon-zaehlereinbau.png" />
          </div>
          <div class="placeholder-label" [innerHTML]="'installation-data.new-installation' | translate"></div>
        </div>
      </div>
    </div>

    <div
      class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-4 ui-sm-6 ui-xs-6 tiles-padding"
      *ngIf="!isCustomer && item.id === 'update-installation' && item.display">
      <div id="update-installation" class="pointer-cursor" (click)="redirectTo(installationFlowType.UpdateInstallation)">
        <div class="placeholder-tiles">
          <div class="placeholder-img">
            <img alt="zaehler aenderung" src="assets/images/icon-zaehler-aenderung.png" />
          </div>
          <div class="placeholder-label">{{ 'installation-data.update-installation' | translate }}</div>
        </div>
      </div>
    </div>

    <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-4 ui-sm-6 ui-xs-6 tiles-padding" *ngIf="item.id === 'mains-connection' && item.display">
      <div id="mains-connection" class="pointer-cursor" (click)="redirectTo(installationFlowType.MainsConnection)">
        <div class="placeholder-tiles">
          <div class="placeholder-img">
            <img alt="netzanschluss" src="assets/images/icon-netzanschluss.png" />
          </div>
          <div class="placeholder-label">{{ 'installation-data.mains-connection' | translate }}</div>
        </div>
      </div>
    </div>

    <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-4 ui-sm-6 ui-xs-6 tiles-padding" *ngIf="showFeedInSystemForCustomer(item)">
      <div id="feed-in-system" class="pointer-cursor" (click)="redirectTo(installationFlowType.FeedInSystem)">
        <div class="placeholder-tiles">
          <div class="placeholder-img">
            <img alt="einspeisung" src="assets/images/icon-einspeisung.png" />
          </div>
          <div class="placeholder-label">{{ 'installation-data.feed-in-system' | translate }}</div>
        </div>
      </div>
    </div>

    <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-4 ui-sm-6 ui-xs-6 tiles-padding" *ngIf="item.id === 'temporary-connection' && item.display">
      <div id="temporary-connection" class="pointer-cursor" (click)="redirectTo(installationFlowType.TemporaryConnection)">
        <div class="placeholder-tiles">
          <div class="placeholder-img">
            <img alt="zeitl. Anschluss" src="assets/images/icon-zeitl-anschluss.png" />
          </div>
          <div class="placeholder-label">{{ 'installation-data.temporary-connection' | translate }}</div>
        </div>
      </div>
    </div>

    <div
      class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-4 ui-sm-6 ui-xs-6 tiles-padding"
      *ngIf="!isCustomer && item.id === 'site-electricity-meterdata' && item.display">
      <div
        id="site-electricity-meterdata"
        class="pointer-cursor"
        [class.tile-disabled]="technicianData?.concession_power === '0'"
        (click)="redirectTo(installationFlowType.SiteElectricityMeterdata)">
        <div class="placeholder-tiles">
          <div class="placeholder-img">
            <img alt="zeitl. Anschluss" src="assets/images/icon-zeitl-anschluss.png" />
          </div>
          <div class="placeholder-label">{{ 'installation-data.site-electricity-meterdata' | translate }}</div>
        </div>
      </div>
    </div>

    <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-4 ui-sm-6 ui-xs-6 tiles-padding" *ngIf="showChangeOfHouseConnection(item)">
      <div id="change-house-connection" class="pointer-cursor" (click)="redirectTo(installationFlowType.ChangeHouseConnection)">
        <div class="placeholder-tiles">
          <div class="placeholder-img">
            <img alt="netzanschluss aenderung" src="assets/images/icon-netzanschluss-aenderung.png" />
          </div>
          <div class="placeholder-label">{{ 'installation-data.change-house-connection' | translate }}</div>
        </div>
      </div>
    </div>

    <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-4 ui-sm-6 ui-xs-6 tiles-padding" *ngIf="item.id === 'conversion-to-gas' && item.display">
      <div id="conversion-to-gas" class="pointer-cursor" (click)="redirectTo(installationFlowType.ConversionToGas)">
        <div class="placeholder-tiles">
          <div class="placeholder-img">
            <img alt="gas u. fernwaerme" src="assets/images/icon-gas-fernwaerme.png" />
          </div>
          <div class="placeholder-label">{{ 'installation-data.conversion-to-gas' | translate }}</div>
        </div>
      </div>
    </div>

    <!-- NEW LSW features -->
    <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-4 ui-sm-6 ui-xs-6 tiles-padding" *ngIf="item.id === 'grid-compatibility' && item.display">
      <div id="grid-compatibility" class="pointer-cursor" (click)="redirectTo(installationFlowType.GridCompatibility)">
        <div class="placeholder-tiles">
          <div class="placeholder-img">
            <img alt="gas u. fernwaerme" src="assets/images/icon-grid-comp.png" />
          </div>
          <div class="placeholder-label">{{ 'installation-data.grid-comp' | translate }}</div>
        </div>
      </div>
    </div>

    <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-4 ui-sm-6 ui-xs-6 tiles-padding" *ngIf="item.id === 'reg-ep' && item.display && !isCustomer">
      <div id="reg-ep" class="pointer-cursor" (click)="redirectTo(installationFlowType.RegEP)">
        <div class="placeholder-tiles">
          <div class="placeholder-img">
            <img alt="einspeisung" src="assets/images/icon-einspeisung.png" />
          </div>
          <div class="placeholder-label">{{ 'installation-data.reg-ep' | translate }}</div>
        </div>
      </div>
    </div>
    <!-- -->
  </ng-container>
</div>

<div class="ui-g component-container" *ngIf="!isApplicationActive">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <h4 class="margin-header-align text-message-align">
      {{ 'installation-data.license-under-review-message' | translate }}
    </h4>
  </div>
</div>

<app-loader *ngIf="isLoading"></app-loader>

<p-confirmDialog
  key="new-app-confirm"
  data-testId="new-app-confirm"
  #confirmDialog
  icon="pi pi-info-circle"
  message="{{ 'basic-profile.jurisdiction.new-application-confirm-text' | translate }}"
  styleClass="netz-confirm-dialog">
  <p-footer>
    <button (click)="confirmDialog.accept()" label="{{ 'yes-button-label' | translate }}" pButton type="button"></button>
    <button (click)="confirmDialog.reject()" label="{{ 'no-button-label' | translate }}" pButton type="button"></button>
  </p-footer>
</p-confirmDialog>
